import { fetchApi } from '@/config/axiosSetting';
import {
  GetFabVehicleImagesQueryFunctionParamsType,
  GetFabVehicleImagesQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabVehicleImages/getFabVehicleImagesQuery.type';

export const getFabVehicleImagesFunction = (
  params: GetFabVehicleImagesQueryFunctionParamsType,
): Promise<GetFabVehicleImagesQueryResponseType> =>
  fetchApi.get(params.url, { params: { damaged_id: params.damagedId } });
